import { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';

import AlertModal from "../Commons/AlertModal";

import { getLabel } from "../../tools/Dictionary";
import { getError, setError } from "../../slices/errorSlice";


const AuthVersion = () =>
{



  //Redux
  const Dispatch = useDispatch();
  const Error = useSelector(getError);

  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  useEffect(() => {
  
    if (Error.code != ""){

      switch (Error.code) {
        //Wrong Client Version
        case "001":
          setAlert({
            Title: getLabel("App", "Error"),
            Message: getLabel("App", "A new version of this application is..."),
            Confirm: getLabel("App", "Refresh"),
            onConfirm: () => window.location.reload(),
            Display: true
          }); 
          break;
      
        default:
          Dispatch(setError(""));
          break;
      }


    }

  }, [Error, Dispatch]);


  return (
    <AlertModal
      Title={alert.Title}
      Message={alert.Message}
      Confirm={alert.Confirm}
      onConfirm={alert.onConfirm}
      Display={alert.Display}
    />
  );

};

export default AuthVersion